firstValueIndex_1